export default __webpack_public_path__ + "images/WX.1c9db9f.png";